exports = module.exports = require("../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".material-symbols {\n\t-webkit-user-select: none;\n\t   -moz-user-select: none;\n\t        user-select: none;\n\tfont-weight: normal;\n\tfont-style: normal;\n\tfont-size: inherit;\n\tdisplay: inline-block;\n\tline-height: 1;\n\ttext-transform: none;\n\tletter-spacing: normal;\n\tword-wrap: normal;\n\twhite-space: nowrap;\n\tdirection: ltr;\n}\n", ""]);

// exports
